export default {
  en: {
    emailHistory: 'Email History',
    dateTime: 'Date Time',
    senderName: 'Sender Name',
    sendTo: 'Send To',
    subject: 'Subject',
    detail: 'Detail',
    to: 'To',
    cc: 'Cc',
    bcc: 'Bcc',
    market: 'Market',
    agent: 'Agent',
    agentType: 'Agent Type',
    type: 'Type',
    emailType: 'Email Type',
    contract: 'Contract',
    specialOffer: 'Special Offer',
    general: 'General',
    stopSale: 'Stop Sale',
    refCode: 'Ref Code',
    agentName: 'Agent',
    included: 'Included',
    all: 'All',
    selectDate: 'Select Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    reset: 'Reset',
    hotel: 'Hotel',
    sendingResult: 'Sending Result'
  },
  th: {
    emailHistory: 'ประวัติการส่งอีเมล',
    dateTime: 'วันเวลา',
    senderName: 'ชื่อผู้ส่ง',
    sendTo: 'ส่งถึง',
    subject: 'หัวข้อ',
    detail: 'รายละเอียด',
    to: 'ส่งถึง',
    cc: 'Cc',
    bcc: 'Bcc',
    market: 'ตลาด',
    agent: 'ตัวแทน',
    agentType: 'ประเภทตัวแทน',
    type: 'ประเภท',
    emailType: 'ประเภทอีเมล',
    contract: 'สัญญา',
    specialOffer: 'ข้อเสนอพิเศษ',
    general: 'ทั่วไป',
    stopSale: 'หยุดการขาย',
    refCode: 'รหัสอ้างอิง',
    agentName: 'ตัวแทน',
    included: 'Included',
    all: 'ทั้งหมด',
    selectDate: 'เลือกวันที่',
    startDate: 'ตั้งแต่',
    endDate: 'สิ้นสุด',
    search: 'ค้นหา',
    reset: 'ล้างค่า',
    hotel: 'โรงแรม',
    sendingResult: 'ผลลัพธ์ของการส่ง'
  }
}
